import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ferris/react/components/button';

export const NextButton = ({
    pinText,
    submitText,
    onClick,
    disabled,
    showDisclaimer
}) => {
    const ButtonToUse = Button;
    return (
        <>
            {
                showDisclaimer && <div className="ulx-pin-disclaimer">{pinText}</div>
            }
            <div className="ulx-location-wrapper__bottom">

                <ButtonToUse
                    isFullWidth
                    classes="btn-fadein"
                    data-wdio="location-next-button"
                    htmlButtonType="button"
                    type="primary"
                    onClick={onClick}
                    id="locationTypeAheadNextBtn"
                    disabled={disabled}
                >
                    {submitText}
                </ButtonToUse>

            </div>
        </>
    );
};

NextButton.propTypes = {
    pinText: PropTypes.string.isRequired,
    submitText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    showDisclaimer: PropTypes.bool.isRequired
};

export default NextButton;
